(() => {
  if (customElements.get('serum-review-carousel')) return;
  class SerumReviewCarousel extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      this.viewport = this.querySelector('.ksr__viewport');
      this.track = this.querySelector('.ksr__track');
      this.originals = [...this.track.children];
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.rebuild = this.rebuild.bind(this);
      this.motion.addEventListener('change', this.rebuild, { signal: this.abort.signal });
      this.observer = new ResizeObserver(this.rebuild);
      this.observer.observe(this.viewport);
      this.rebuild();
    }
    rebuild() {
      const oldTime = Number(this.animation?.currentTime) || 0;
      this.animation?.cancel();
      this.track.querySelectorAll('[data-review-clone]').forEach(node => node.remove());
      if (this.motion.matches || !this.originals.length) return;
      const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
      const period = this.originals.reduce((total, card) => total + card.getBoundingClientRect().width + gap, 0);
      if (!period) return;
      const copies = Math.ceil(this.viewport.clientWidth / period) + 1;
      for (let copy = 0; copy < copies; copy++) {
        for (const original of this.originals) {
          const clone = original.cloneNode(true);
          clone.dataset.reviewClone = 'true';
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          clone.removeAttribute('id');
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          this.track.append(clone);
        }
      }
      this.animation = this.track.animate(
        [{ transform: 'translateX(0)' }, { transform: 'translateX(-' + period + 'px)' }],
        { duration: period / 24 * 1000, iterations: Infinity, easing: 'linear' }
      );
      this.animation.currentTime = oldTime % (period / 24 * 1000);
    }
    disconnectedCallback() {
      this.animation?.cancel();
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
      this.track?.querySelectorAll('[data-review-clone]').forEach(node => node.remove());
    }
  }
  customElements.define('serum-review-carousel', SerumReviewCarousel);
})();
